import { createStore } from 'vuex'

export default createStore({
  state: {
    baseUrl:"https://www.qh-ps.cn/api"
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
